import React, { useState } from 'react';
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Collapse,
    Typography,
    Grid,
    TextField,
    Backdrop,
    Button,
    CircularProgress
} from '@mui/material';

import { usePresale } from '../../contexts/PresaleContext';

const SubmissionRow = ({ submission }) => {
    const [open, setOpen] = useState(false);

    const handleToggle = () => setOpen(!open);

    return (
        <>
            <TableRow
                hover
                onClick={handleToggle}
                sx={{
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    '&:hover': {
                        backgroundColor: '#2a2a2a'
                    }
                }}
            >
                <TableCell sx={{ color: '#fff' }}>{submission.poolName}</TableCell>
                <TableCell sx={{ color: '#fff' }}>{submission.twitter}</TableCell>
                <TableCell sx={{ color: '#fff' }}>{submission.type}</TableCell>
                <TableCell sx={{ color: '#fff' }}>{submission.size}</TableCell>
                <TableCell sx={{ color: '#fff' }}>{new Date(submission.createDate).toLocaleString()}</TableCell>
                <TableCell align="right">
                    <Button
                        size="small"
                        variant="outlined"
                        sx={{ color: '#efbc00', borderColor: '#749d1a', textTransform: 'none' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleToggle();
                        }}
                    >
                        {open ? 'Hide Details' : 'View Details'}
                    </Button>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={5} sx={{ p: 0 }}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ backgroundColor: '#1e1e1e', px: 3, py: 2 }}>
                            <Typography variant="subtitle1" sx={{ color: '#efbc00', mb: 2 }}>
                                Submission Details
                            </Typography>
                            <Grid container spacing={2}>
                                {/* Top fields */}
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label="Pool Name"
                                        value={submission.poolName}
                                        fullWidth
                                        multiline
                                        InputLabelProps={{ style: { color: '#efbc00', fontWeight: 600 } }}
                                        InputProps={{
                                            readOnly: true,
                                            style: {
                                                color: '#ccc',
                                                backgroundColor: '#1e1e1e',
                                                borderColor: '#749d1a'
                                            },
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': { borderColor: '#749d1a' },
                                            },
                                            mb: 2
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label="Wallet"
                                        value={submission.wallet}
                                        fullWidth
                                        InputLabelProps={{ style: { color: '#efbc00', fontWeight: 600 } }}
                                        InputProps={{
                                            readOnly: true,
                                            style: {
                                                color: '#ccc',
                                                backgroundColor: '#1e1e1e',
                                                borderColor: '#749d1a'
                                            },
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#749d1a' } }, mb: 2 }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label="Twitter"
                                        value={submission.twitter}
                                        fullWidth
                                        InputLabelProps={{ style: { color: '#efbc00', fontWeight: 600 } }}
                                        InputProps={{
                                            readOnly: true,
                                            style: {
                                                color: '#ccc',
                                                backgroundColor: '#1e1e1e'
                                            },
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#749d1a' } }, mb: 2 }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label="Size"
                                        value={submission.size}
                                        fullWidth
                                        InputLabelProps={{ style: { color: '#efbc00', fontWeight: 600 } }}
                                        InputProps={{
                                            readOnly: true,
                                            style: {
                                                color: '#ccc',
                                                backgroundColor: '#1e1e1e'
                                            },
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#749d1a' } }, mb: 2 }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label="Type"
                                        value={submission.type}
                                        fullWidth
                                        InputLabelProps={{ style: { color: '#efbc00', fontWeight: 600 } }}
                                        InputProps={{
                                            readOnly: true,
                                            style: {
                                                color: '#ccc',
                                                backgroundColor: '#1e1e1e'
                                            },
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#749d1a' } }, mb: 2 }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label="Telegram"
                                        value={submission.telegram || ''}
                                        fullWidth
                                        InputLabelProps={{ style: { color: '#efbc00', fontWeight: 600 } }}
                                        InputProps={{
                                            readOnly: true,
                                            style: {
                                                color: '#ccc',
                                                backgroundColor: '#1e1e1e'
                                            },
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#749d1a' } }, mb: 2 }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        label="About"
                                        value={submission.about}
                                        multiline
                                        rows={3}
                                        fullWidth
                                        InputLabelProps={{ style: { color: '#efbc00', fontWeight: 600 } }}
                                        InputProps={{
                                            readOnly: true,
                                            style: {
                                                color: '#ccc',
                                                backgroundColor: '#1e1e1e'
                                            },
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#749d1a' } }, mb: 2 }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        label="Notes"
                                        value={submission.notes || 'No additional notes'}
                                        multiline
                                        rows={3}
                                        fullWidth
                                        InputLabelProps={{ style: { color: '#efbc00', fontWeight: 600 } }}
                                        InputProps={{
                                            readOnly: true,
                                            style: {
                                                color: '#ccc',
                                                backgroundColor: '#1e1e1e'
                                            },
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#749d1a' } }, mb: 2 }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="caption" sx={{ color: '#ccc' }}>
                                        Submitted on: {new Date(submission.createDate).toLocaleString()}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>

        </>
    );
};

const PresaleSubmissions = () => {
    const { submissions, isModalLoading } = usePresale();

    return (
        <div className="main details" style={{ marginTop: 100, marginBottom: 400 }} >
            <section className="user-profile flat-tabs" style={{ padding: 0 }}>
                <div className="container" style={{ padding: 0 }}>
                    <Box sx={{ mt: 4, mb: 4, px: { xs: 2, md: 8 } }}>
                        <Typography variant="h4" sx={{ color: '#efbc00', mb: 1 }}>
                            Presale Pool Submissions
                        </Typography>
                        <Typography variant="h6" sx={{ color: '#749d1a', mb: 3, marginTop: 2 }}>
                            Total submissions: {submissions?.length || 0}
                        </Typography>

                        <TableContainer component={Paper} sx={{ backgroundColor: '#121212', boxShadow: 3, marginTop: 5, marginBottom: 10 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ color: '#efbc00' }}>Pool Name</TableCell>
                                        <TableCell sx={{ color: '#efbc00' }}>Twitter</TableCell>
                                        <TableCell sx={{ color: '#efbc00' }}>Type</TableCell>
                                        <TableCell sx={{ color: '#efbc00' }}>Size</TableCell>
                                        <TableCell sx={{ color: '#efbc00' }}>Date</TableCell>
                                        <TableCell sx={{ color: '#efbc00' }} align="right">Details</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {submissions && submissions.map((submission) => (
                                        <SubmissionRow key={submission._id} submission={submission} />
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
            </section>
            <Backdrop
                open={isModalLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default PresaleSubmissions;
